<template>
  <div class="user-agreement-container">
    
    
    <div class="content">
      <!-- <h1>用户协议</h1> -->
      <div  v-html="parsedMarkdown"></div>
      <div id="parsedMarkdown1" v-html="parsedMarkdown1"></div>
      <div id="parsedMarkdown2" v-html="parsedMarkdown2"></div>
      <div id="parsedMarkdown3" v-html="parsedMarkdown3"></div>
      <div id="parsedMarkdown4" v-html="parsedMarkdown4"></div>
      <div id="parsedMarkdown5" v-html="parsedMarkdown5"></div>
      <div id="parsedMarkdown6" v-html="parsedMarkdown6"></div>
      <div id="parsedMarkdown7" v-html="parsedMarkdown7"></div>
      <div id="parsedMarkdown8" v-html="parsedMarkdown8"></div>
      <div id="parsedMarkdown9" v-html="parsedMarkdown9"></div>
    </div>
    <!-- <div class="sidebar">
      <h3>目录</h3>
      <ul>
        <li v-for="item in outline" :key="item.id" @click="scrollToHeading(item.id)">
          {{ item.title }}
        </li>
      </ul>
    </div> -->
  </div>
</template>

<script>
import { marked } from 'marked';

export default {
  data() {
    return {
      markdownContent: `&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;欢迎使用Linkoffer提供的服务。本协议是您（以下简称“用户”）与本网站（以下简称“本平台”）之间就注册、
      使用平台提供的服务所达成的合法协议。 \n为保障您的权益，请您在使用平台前仔细阅读以下协议内容。使用本平台及服务，
      即表示您已阅读并同意遵守本协议的所有条款。 `,
      markdownContent1: `\n\n## 一. 服务定位 
      \n 1.1 本平台提供的用于学习、训练、模拟为目的面试能力提升服务，帮助用户提升面试能力和技术素养； 
      \n 1.2 本平台服务仅以提升面试能力为目的，不得用于其他目的 。`,
      markdownContent2: `\n\n## 二. 账户与安全
      \n 2.1 用户应使用真实有效的手机号、邮箱进行注册； 
      \n 2.2 用户有义务妥善保管账户，如因用户自身原因导致的账户泄露、信息丢失，平台不承担责任； 
      \n 2.3 账户注销 
      \n（1）用户可以在个人中心注销其平台账户；
      \n（2）若账户存在未完成的交易或未结清的款项、涉嫌违规等情况，平台有权在问题解决后再行处理注销申请； 
      \n（3）注销后，用户将无法继续使用本平台提供的任何服务，相关账户数据将被永久删除（但法律法规另有规定的除外），
      且信息一经删除不可恢复，如因此造成损失的，平台不承担任何责任； 
      \n（4）平台将在用户发起注销请求后，在15个工作日内完成账户注销及个人信息的清除工作，
      \n包括但不限于注册信息、使用记录、充值记录、积分信息等； 
      \n（5）注销后，用户与平台之间的所有服务协议即时终止，平台不再承担任何服务或技术支持义务。 `,
      markdownContent3: `\n\n## 三. 数据合规 
      \n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;平台将严格按照《中华人民共和国个人信息保护法》等相关法律法规的规定，收集、使用、\n存储和保护用户的个人信息，除本平台服务必要需求外，非必要信息不作收集、存储，敏感数据将作用户本地存储。 `,
      markdownContent4: `\n\n## 四. 用户行为规范 
      \n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;用户在使用本平台服务时，承诺以下内容： 
      \n 4.1 用户所提交的资料真实、完整，不存在虚假信息； 
      \n 4.2 用户不得冒用他人身份注册账户，不得重复注册多个账号恶意获取平台资源，不得通过虚假手机号及邮箱，\n或其他虚假信息恶意注册账户。如有违法行为，平台有依法追溯权利； 
      \n 4.3 用户在使用平台服务时，必须遵守中华人民共和国的法律法规，不得利用平台从事任何违法、违规行为：\n包括不限于利用平台服务参与任何形式的虚假招聘、非法代考、技术欺诈、身份伪造等违法行为；
       \n 4.4 用户承诺所有模拟面试行为仅为个人学习目的，不用于工作、学术等面试中的作弊行为；
        \n 4.5 用户不得通过任何技术手段试图绕过计费系统，不得进行任何可能破坏、干扰、修改或影响本平台正常运作的行为。\n如有违法行为，平台有依法追溯权利。 `,
      markdownContent5: `\n\n## 五. 平台权利 
      \n 5.1 平台有权在发现用户存在违规或违法行为时，\n立即暂停或终止服务，并有权依法向有关部门报备； 
      \n 5.2 必要情形下，平台保留对用户使用记录进行存档、审查和分析的权利； `,
      markdownContent6: `\n\n## 六. 知识产权 
      \n 6.1 平台的所有内容，包括但不限于界面设计、生成内容、技术服务、相关数据等，均受相关知识产权法律保护； 
      \n 6.2 未经许可，用户不得复制、传播、商业使用平台内容； 
      \n 6.3 用户需承诺，在使用本服务时提交的信息不侵犯他人合法权益，也不涉及国家秘密、商业机密或其他敏感数据。\n如因用户的行为引发纠纷或损失，用户将自行承担全部责任，并赔偿平台的损失。 `,
      markdownContent7: `\n\n## 七. 免责声明 
      \n 7.1 用户因违反本协议而引发的任何法律责任，平台不承担任何连带责任；
       \n 7.2 用户在使用平台服务过程中，因自身行为导致的任何损失或法律责任，平台不承担责任； 
      \n 7.3 平台提供的模拟评估及回答仅供参考，不构成正式意见。平台不对用户参与第三方面试、招聘等行为承担任何结果责任；
       \n 7.4 平台将尽力确保服务的连续性和安全性，但因不可抗力或其他非平台原因导致的服务中断或数据丢失除外。 `,
      markdownContent8: `\n\n## 八. 协议变更 
      \n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;平台有权根据需要修改本协议，修改后的协议将通过平台公告或其他适当方式通知用户。用户继续使用平台服务，\n即视为接受修改后的协议。`,
      markdownContent9: ` \n\n## 九. 法律适用 
      \n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。\n因本协议引起的或与本协议有关的争议，双方应友好协商解决；协商不成的，任何一方均可向平台所在地有管辖权的人民法院提起诉讼。 
      \n\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;感谢您遵守规范，共同打造真实、可信、专业的技术成长社区。 \n如您有任何疑问、建议或投诉，请通过以下方式与我们联系： \n邮箱：`,
      outline: [
        { id: 'parsedMarkdown1', title: '一. 服务定位' },
        { id: 'parsedMarkdown2', title: '二. 账户与安全' },
        { id: 'parsedMarkdown3', title: '三. 数据合规' },
        { id: 'parsedMarkdown4', title: '四. 用户行为规范' },
        { id: 'parsedMarkdown5', title: '五. 平台权利' },
        { id: 'parsedMarkdown6', title: '六. 知识产权' },
        { id: 'parsedMarkdown7', title: '七. 免责声明' },
        { id: 'parsedMarkdown8', title: '八. 协议变更' },
        { id: 'parsedMarkdown9', title: '九. 法律适用' }
      ]
    };
  },
  computed: {
    parsedMarkdown() {
      return marked(this.markdownContent);
    },
    parsedMarkdown1() {
      return marked(this.markdownContent1);
    },
    parsedMarkdown2() {
      return marked(this.markdownContent2);
    },
    parsedMarkdown3() {
      return marked(this.markdownContent3);
    },
    parsedMarkdown4() {
      return marked(this.markdownContent4);
    },
    parsedMarkdown5() {
      return marked(this.markdownContent5);
    },
    parsedMarkdown6() {
      return marked(this.markdownContent6);
    },
    parsedMarkdown7() {
      return marked(this.markdownContent7);
    },
    parsedMarkdown8() {
      return marked(this.markdownContent8);
    },
    parsedMarkdown9() {
      return marked(this.markdownContent9);
    }
  },
  methods: {
    scrollToHeading(id) {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      this.activeSection = id;
    }
  }
};
</script>

<style scoped>
.user-agreement-container {
  position: relative;
  display: flex;
  padding: 0px;
}
.sidebar {
  width: 200px;
  margin-right: 20px;
  margin-left: 100px;
  position: sticky;
  top: 20px;
  height: calc(100vh - 40px);
  overflow-y: auto;
}
.content {
  flex-grow: 1;
  max-width: 800px;
  margin-left: 0px;
  /* 左侧空出 40px */
}
.content p {
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 0px;
}
.sidebar ul {
  list-style-type: none;
  padding: 0;
}
.sidebar li {
  margin-bottom: 10px;
  cursor: pointer;
}

h1 {
  font-size: 40px; /* 调整字体大小 */
  color: #333;
  margin-bottom: 20px;
  text-align: center;
}
.content div[id^='parsedMarkdown'] {
  transition: color 0.3s;
}
.content div[id^='parsedMarkdown'].active {
  color: #007bff;
}

/* 移动设备适配 */
@media (max-width: 768px) {
  .user-agreement-container {
    flex-direction: column;
    padding: 0;
  }
  
  .sidebar {
    width: 100%;
    margin: 0;
    position: static;
    height: auto;
    overflow-y: visible;
    margin-bottom: 20px;
    padding: 0 16px;
  }
  
  .content {
    max-width: 100%;
    margin-left: 0;
    padding: 0 16px;
  }
  
  .content p {
    margin-top: 8px;
    margin-bottom: 8px;
    font-size: 14px;
    line-height: 1.6;
  }
  
  h1 {
    font-size: 24px;
    margin-bottom: 16px;
    padding: 0 16px;
  }
  
  .sidebar ul {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .sidebar li {
    margin-bottom: 0;
    padding: 8px 12px;
    background: #f5f5f5;
    border-radius: 6px;
    font-size: 13px;
    white-space: nowrap;
  }
  
  .sidebar li:hover {
    background: #e0e0e0;
  }
  
  .content div[id^='parsedMarkdown'] {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .content div[id^='parsedMarkdown'] h2 {
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 12px;
  }
  
  .content div[id^='parsedMarkdown'] h3 {
    font-size: 16px;
    margin-top: 16px;
    margin-bottom: 10px;
  }
  
  .content div[id^='parsedMarkdown'] h4 {
    font-size: 15px;
    margin-top: 14px;
    margin-bottom: 8px;
  }
}

/* 平板设备适配 */
@media (min-width: 769px) and (max-width: 1024px) {
  .user-agreement-container {
    padding: 0 20px;
  }
  
  .sidebar {
    width: 180px;
    margin-left: 60px;
  }
  
  .content {
    max-width: 700px;
  }
  
  .content p {
    font-size: 15px;
    line-height: 1.7;
  }
  
  h1 {
    font-size: 32px;
  }
  
  .sidebar li {
    font-size: 14px;
    padding: 6px 8px;
  }
  
  .content div[id^='parsedMarkdown'] {
    font-size: 15px;
    line-height: 1.7;
  }
  
  .content div[id^='parsedMarkdown'] h2 {
    font-size: 20px;
  }
  
  .content div[id^='parsedMarkdown'] h3 {
    font-size: 18px;
  }
  
  .content div[id^='parsedMarkdown'] h4 {
    font-size: 16px;
  }
}

/* 小屏手机适配 */
@media (max-width: 480px) {
  .sidebar {
    padding: 0 12px;
    margin-bottom: 16px;
  }
  
  .content {
    padding: 0 12px;
  }
  
  .content p {
    font-size: 13px;
    line-height: 1.5;
  }
  
  h1 {
    font-size: 20px;
    margin-bottom: 12px;
    padding: 0 12px;
  }
  
  .sidebar ul {
    gap: 6px;
  }
  
  .sidebar li {
    padding: 6px 10px;
    font-size: 12px;
  }
  
  .content div[id^='parsedMarkdown'] {
    font-size: 13px;
    line-height: 1.5;
  }
  
  .content div[id^='parsedMarkdown'] h2 {
    font-size: 16px;
    margin-top: 16px;
    margin-bottom: 10px;
  }
  
  .content div[id^='parsedMarkdown'] h3 {
    font-size: 15px;
    margin-top: 14px;
    margin-bottom: 8px;
  }
  
  .content div[id^='parsedMarkdown'] h4 {
    font-size: 14px;
    margin-top: 12px;
    margin-bottom: 6px;
  }
}

/* 横屏手机适配 */
@media (max-width: 900px) and (max-height: 600px) {
  .user-agreement-container {
    flex-direction: row;
    gap: 20px;
  }
  
  .sidebar {
    width: 150px;
    margin: 0;
    position: sticky;
    top: 10px;
    height: calc(100vh - 20px);
    overflow-y: auto;
    padding: 0 10px;
  }
  
  .content {
    flex: 1;
    max-width: none;
    padding: 0 10px;
  }
  
  .content p {
    font-size: 13px;
    line-height: 1.5;
  }
  
  h1 {
    font-size: 18px;
    margin-bottom: 12px;
  }
  
  .sidebar li {
    font-size: 12px;
    padding: 4px 6px;
    margin-bottom: 6px;
  }
  
  .content div[id^='parsedMarkdown'] {
    font-size: 13px;
    line-height: 1.5;
  }
  
  .content div[id^='parsedMarkdown'] h2 {
    font-size: 15px;
    margin-top: 12px;
    margin-bottom: 8px;
  }
  
  .content div[id^='parsedMarkdown'] h3 {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 6px;
  }
  
  .content div[id^='parsedMarkdown'] h4 {
    font-size: 13px;
    margin-top: 8px;
    margin-bottom: 4px;
  }
}
</style>